// Module
var code = "<template>\n  <div class=\"badge\" class.bind=\"`badge--` + type + ' ' + classes\">\n    <slot></slot>\n  </div>\n</template>\n";
// Exports
export default code;